const COMPATIBILITY_RANK = { bestMatch: 0, incompatible: 2 };

/**
 * The Trip Designer's order for experiences next to the selected day: best
 * matches first, incompatible ones last, the rest in their original order.
 * The list and the map's grouped popups share it, so a group opens on the
 * same experience the list shows first.
 */
export function sortByCompatibility(experiences, getCompatibility) {
  const rank = (experience) =>
    COMPATIBILITY_RANK[getCompatibility(experience)] ?? 1;

  return [...(experiences ?? [])].sort((a, b) => rank(a) - rank(b));
}
